import React, { useMemo, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import SharedScript from '@americanexpress/shared-scripts';
import { getProductsRegistryMap } from '@americanexpress/product-ducks';
import PropTypes from 'prop-types';

export default function UniversalSessionManager({
  locale, oneIdentity, pathname, originLocation,
}) {
  const productsMap = useSelector(getProductsRegistryMap, shallowEqual);
  const isAuthenticated = useMemo(() => Object.keys(productsMap)?.length > 0, [productsMap]);
  const amexSessionFlag = !!(global.BROWSER && window && window.AmexSession);

  useEffect(() => {
    if (isAuthenticated && amexSessionFlag) {
      const targetURL = `${oneIdentity}/${locale.toLowerCase()}/account/login?DestPage=${originLocation}${pathname}`;
      window.AmexSession.options({
        target: encodeURIComponent(targetURL),
      });
    }
  }, [isAuthenticated, pathname, amexSessionFlag, locale, oneIdentity, originLocation]);

  return isAuthenticated
    ? <SharedScript name="one-identity-session" version="^1.8.1" windowCheck="AmexSession" />
    : null;
}

UniversalSessionManager.propTypes = {
  locale: PropTypes.string.isRequired,
  oneIdentity: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
  originLocation: PropTypes.string.isRequired,
};
